import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'
import { DdcCardCategoryComponent } from '../ddc-card-category/ddc-card-category.component'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'

@Component({
  selector: 'ddc-search-result-word',
  templateUrl: './ddc-search-result-word.component.html',
  styleUrl: './ddc-search-result-word.component.scss',
  imports: [
    CommonModule,
    AngularMaterialsModules,
    DdcCountryFlagComponent,
    DdcCardCategoryComponent,
  ],
})
export class DdcSearchResultWordComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() wordClick = new EventEmitter<number>()

  onWordClick(): void {
    if (this.result?.id) {
      this.wordClick.emit(this.result.id)
    }
  }
}
